export default __webpack_public_path__ + "078c954a7e3c7b68639b3a5fbe448e8e.png";